var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerificationSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 6.78571C12.0006 5.88286 11.5006 5.1 10.7731 4.72857C10.8611 4.48 10.9091 4.21143 10.9091 3.92857C10.9091 2.66571 9.932 1.644 8.72743 1.644C8.45886 1.644 8.20171 1.692 7.964 1.78686C7.61086 1.02286 6.86343 0.5 6.00057 0.5C5.13771 0.5 4.39143 1.024 4.03657 1.78571C3.79943 1.69143 3.54171 1.64286 3.27314 1.64286C2.06743 1.64286 1.09143 2.66571 1.09143 3.92857C1.09143 4.21086 1.13886 4.47943 1.22686 4.72857C0.5 5.1 0 5.88171 0 6.78571C0 7.64 0.446857 8.38457 1.10971 8.77771C1.09829 8.87486 1.09143 8.972 1.09143 9.07143C1.09143 10.3343 2.06743 11.3571 3.27314 11.3571C3.54171 11.3571 3.79886 11.308 4.036 11.2143C4.39029 11.9766 5.13657 12.5 6 12.5C6.864 12.5 7.61029 11.9766 7.964 11.2143C8.20114 11.3074 8.45829 11.356 8.72743 11.356C9.93314 11.356 10.9091 10.3331 10.9091 9.07029C10.9091 8.97086 10.9023 8.87371 10.8903 8.77714C11.552 8.38457 12.0006 7.64 12.0006 6.78629V6.78571Z",
    fill: "#0945EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5L5.25 7.75L4 6.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationSolid);
export default __webpack_public_path__ + "static/media/verification-solid.d34934ac070c62fcb2b1d2b803acef7f.svg";
export { ForwardRef as ReactComponent };